<template>
  <transition name="modal">
    <section class="popup-services">
      <div class="popup-services--content">
        <div class="popup-heading">
          <a
            aria-role="button"
            aria-label="close"
            href="#footer"
            class="popup-services__close"
            @click="$emit('close')"
          >&times;</a>

          <br />
        </div>
        <div class="info__content">
          <div class="info__content--text u-margin-bottom-large">
            <h4 class="heading-tertiary">About</h4>
            <p class="paragraph service__paragraph u-margin-bottom-medium">
              Located in my hometown of Cañon City, CO, I'm thrilled to offer my community a more intimate approach to photography!
              The experience throughout the entire process of booking, shooting, and revealing your session should be as excellent as the portraits themselves. I take great care in customizing a physically comfortable space and a stress-free environment with the intention of being a retreat from the otherwise hectic nature of birth, parenthood, doctor appointments, visitors, etc. I want this to be a time to pause and relish your new addition while I compose tangible memories.
              Two of my main focuses in every interaction are safety and communication.
            </p>
            <p class="paragraph service__paragraph u-margin-bottom-medium">
              <strong>Safety:</strong>
              <ul class="u-margin-bottom-medium u-margin-left-medium">
                <li>I use the hypoallergenic Dreft newborn detergent for washing all fabrics between use.</li>
                <li>I've upgraded to a hospital grade disinfectant to thoroughly clean the floor and all other surfaces before your arrival.</li>
                <li>All props and fabrics are hand picked and regularly inspected with your child's safety in mind.</li>
                <li>I use only age-appropriate poses your child seems comfortable with and ensure appropriate spotting is used.</li>
              </ul>
              <strong >Communication:</strong>
              <ul class="u-margin-left-medium">
                <li>I always schedule a pre-consultation with you. I want to get to know you a little because every family is different! This is also the time to discuss your expectaions so I can tailor your session to run smoothly and to include your "must-haves." It is a time I can outline my best practices for you as well.</li>
                <li>Get excited for an in-person reveal! This is a special time in your life and it deserves a special showcase of the finished work. It also provides the opportunity for genuine feedback and for finalizing any product orders.</li>
              </ul>
            </p>
            <p class="paragraph service__paragraph u-margin-bottom-medium">If you are interested in joining my photography family, you will want to secure a time as early as possible! I only schedule a few sessions each month, so spots fill fast!
              <img id="about-footer-img" src="../assets/IMAGES/about-footer-img.jpg" alt="Photo of Baby Sleeping">

            </p>

          </div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
export default {
  name: "Info",
  metaInfo: {
    title: "Jeanna Chambers",
    titleTemplate: "%s | Info",
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.popup-services {
  // @include clearfix;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background-color: rgba($color-black, 0.8);
  position: fixed;
  z-index: 10000;
  opacity: 1;
  transition: all 0.3s;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch; //we'll see
  backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  @supports (-webkit-backdrop-filter: blur(10px)) or
    (backdrop-filter: blur(10px)) {
    background-color: rgba($color-black, 0.3);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }

  &--content {
    min-width: 100vw;
    min-height: 100vh;
    background-color: $color-coral-light;
    top: 0;
    left: 0;
    padding: 2rem;
    margin: auto;
  }

  &__close {
    &:link,
    &:visited {
      position: fixed;
      top: 2.5rem;
      right: 2.5rem;
      font-size: 6rem;
      text-decoration: none;
      display: inline-block;
      transition: all 0.2s;
      line-height: 1;
      z-index: 11001;
      color: $color-black;
    }

    &:hover {
      color: $color-grey-light-1;
    }
  }
}

.info__content {
  display: flex;
  flex-direction: column;
  padding: 3rem;
  margin: auto;
  max-width: 95%;
  justify-content: space-around;
  // flex-flow: row wrap;

  @include respond(tab-port) {
    align-content: flex-start;
    padding: 0 1rem;
    min-width: 100%;
    min-height: 100vh;
  }

  &--text {
    padding: 1.5rem 6rem;
    // margin-right: -3rem;
    color: $color-black;
    background-color: $color-white;
    font-size: 1.6rem;
    text-align: left;
    margin: auto;

    @include respond(tab-port) {
      padding: 1.5rem 1.5rem;
      width: 90vw;
    }
  }

  &--examples {
    background-color: $color-grey-light-1;
    padding-left: 1rem;
    border-radius: 2rem;
  }

  &--duration {
    color: $color-primary;
    padding: 1rem 1rem;
  }

  &--price {
    color: $color-primary-dark;
    font-size: 2rem;
    text-align: right;
  }

  &--photo {
    box-shadow: 0 1.5rem 4rem rgba($color-black, 0.5);
    border-radius: 2px;
    transition: all 0.2s;
    padding: 1rem;
    flex: 1 2 50%;
    max-width: 50%;
    align-self: flex-start;

    img {
      display: block;
      width: 50%;
      height: auto;
      margin: auto;
    }

    @include respond(tab-port) {
      box-shadow: 0 1.5 3rem rgba($color-black, 0.2);
      // padding: 0 1rem;
      // max-width: 100%;
    }

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 2.5rem 4rem rgba($color-black, 0.5);
      z-index: 20;
    }
  }

  &:hover &__photo:not(:hover) {
    transform: scale(0.95);
  }
}

.info-heading {
  font-size: 2.5rem;
}

#about-footer-img {
  display: block;
  width: 50%;
  margin: auto;
  margin-top: 2rem;
  border-radius: 1rem;

  @include respond(phone) {
    width: 100%;
  }
}
</style>
